
import Api from './Api.service';
export default class EmpleadoService {
    static ObtenerPorDni(dni) {
        return Api.get(`empleado/${dni}`);
    }
}